import type { WindowEdge, WindowSize } from "./Window.types";

export const WINDOW_DEFAULT_SIZE: WindowSize = { width: 360, height: 420 };

export const WINDOW_MIN_SIZE: WindowSize = { width: 240, height: 160 };

export const WINDOW_MARGIN = 12;

export const WINDOW_HANDLE_HEIGHT = 40;

export const WINDOW_EDGES = [
  "n",
  "s",
  "w",
  "e",
  "nw",
  "ne",
  "sw",
  "se",
] as const satisfies readonly WindowEdge[];

export const WINDOW_OPACITY_VAR = "--window-opacity";

export const WINDOW_BLUR_VAR = "--window-blur";
